<template>
  <div class="w-100 wrap">
    <label v-for="(item, index) in filteredRadioList" :key="index" class="item">
      <input class="radio" type="radio" :value="item.value" v-model="picked" style="display: none" />
      {{ item.label }}
      <div></div>
    </label>
    <label class="item">
      <input class="radio" type="radio" value="other" v-model="picked" style="display: none" />
      其他原因
      <div></div>
    </label>
    <div v-if="picked === 'other'" style="margin-top: 8px">
      <cus-input v-model:value="input" placeholder="請輸入..."></cus-input>
    </div>
  </div>
</template>
<script>
export default {
  name: 'cus-radio-column',
  props: {
    radioList: { type: Array },
    selectValue: { type: String, default: null },
    input_reason: { type: String, default: '' },
  },
  computed: {
    picked: {
      get() {
        return this.selectValue;
      },
      set(val) {
        this.$emit('update:selectValue', val);
      },
    },
    input: {
      get() {
        return this.input_reason;
      },
      set(val) {
        this.$emit('update:input_reason', val);
      },
    },

    filteredRadioList() {
      return this.radioList.filter((item) => item.label && item.value);
    },
  },
  watch: {
    picked() {
      if (this.picked !== 'other') this.input = '';
    },
  },
};
</script>
<style lang="scss" scoped>
.wrap {
  display: flex;
  flex-direction: column;
  background-color: $color-gray-3;
  padding: 12px 16px;
}
.item {
  color: $color-gray-60;
  font-size: 2rem;
  cursor: pointer;
  position: relative;
  margin: 4px 0;
  &::before {
    content: '';
    position: absolute;
    width: 24px;
    height: 24px;
    border: 2px solid $color-blue;
    border-radius: 2px;
    right: 0;
    top: 50%;
    transform: translateY(-45%);
  }
  input:checked + div::after {
    content: '';
    position: absolute;
    width: 16px;
    height: 16px;
    background-color: $color-blue;
    border-radius: 2px;
    right: 4px;
    top: 50%;
    transform: translateY(-44%);
  }
}
</style>
